import React from "react";
import PropTypes from "prop-types";

import { InputAdornment, Tooltip } from "@mui/material";

import CustomFormTextInput from "./CustomFormTextInput";
import ReadOnlyInput from "./ReadOnlyInput";

import DollerIcon from "../../Assets/IconComponents/DollerIcon";

export default function CustomCurrencyField({
  rules,
  mode,
  isAddMode,
  label,
  autoCalculatedIcon,
  showAutoCalculatedIcon = false,
  autoCalculatedTooltip,
  ...rest
}) {
  const {
    canView = false,
    canAdd = false,
    canEdit = false
  } = rest.permission || {};

  const autoCalculatedImg = showAutoCalculatedIcon ? (
    <img src={autoCalculatedIcon} alt="Auto calculated" style={{ width: 14, height: 14, display: "block"}} />
  ) : null;

  const autoCalculatedAdornment = autoCalculatedImg && autoCalculatedTooltip ? (
    <Tooltip title={autoCalculatedTooltip} arrow placement="top">
      {autoCalculatedImg}
    </Tooltip>
  ) : autoCalculatedImg;

  if (!canView || (isAddMode && !canAdd)) {
    return null;
  }

  const editModeAllowed = isAddMode ? canAdd : canEdit;

  if ( mode === "read" || (mode === "edit" && !editModeAllowed)) {
    return (
      <ReadOnlyInput
        type="currency"
        {...rest}
        rules={rules}
        label={label}
        labelAdornment={autoCalculatedAdornment}
      />
    );
  }

  return (
    <CustomFormTextInput
      {...rest}
      label={label}
      placeholder={label}
      type="number"
      rules={rules}
      labelAdornment={autoCalculatedAdornment}
      startAdornment={
        <InputAdornment position="start">
          <DollerIcon />
        </InputAdornment>
      }
    />
  );
}

CustomCurrencyField.propTypes = {
  mode: PropTypes.oneOf(["read", "edit"]).isRequired,
  isAddMode: PropTypes.bool,
  rules: PropTypes.object
};